import script from "./AddEditCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEditCustomer.vue?vue&type=script&setup=true&lang=js"

import "./AddEditCustomer.vue?vue&type=style&index=0&id=6fa675d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa675d2"]])

export default __exports__